import type { AuthenticatedSession, Session } from "./session";

export type SessionRecoveryResult =
    | { kind: "recovered"; session: AuthenticatedSession }
    | { kind: "different-account" }
    | { kind: "logged-out" };

export const recoverSessionForOwner = async (
    ownerId: string,
    readCurrentSession: () => Promise<Session>,
): Promise<SessionRecoveryResult> => {
    const session = await readCurrentSession();
    if (!session.authenticated) return { kind: "logged-out" };
    if (session.user.id !== ownerId) return { kind: "different-account" };
    return { kind: "recovered", session };
};

export const isAuthorizationFailure = (response: Response): boolean =>
    response.status === 401 || response.status === 403;
